<template>
  <div class="relative flex items-center gap-4 overflow-hidden rounded-lg py-2">
    <SFSkeletonLoader
      v-for="n in 5"
      :key="n"
      type="custom"
      class="h-[25px] w-[100px] animate-[shimmer_1.2s_linear_infinite] rounded-lg bg-gray-200 bg-gradient-to-r from-transparent via-gray-100 to-transparent bg-[length:400px_100%]"
    />
  </div>
</template>

<script setup lang="ts">
import { SFSkeletonLoader } from '#storefront-ui/components'
</script>
